import React, { useCallback, useEffect, useRef, useState } from "react";
import Webcam from "react-webcam";
import QrScanner from "qr-scanner";
import TriggerClient from "./trigger/trigger_client";
import { Button, Spin } from "antd";
import { LoadingOutlined, ScanOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { defaultSupporterOpenAddSelector } from "store/user/(default)/supporter/default_supporter.selector";
import { useSupporterSearch } from "hook/supporters/useSupporter";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const QRScanner = () => {
  // -------------------------- VAR -----------------------------
  const { loading, handleSearchById } = useSupporterSearch();
  const webcamRef = useRef(null);
  let scanner = useRef(null);
  const [result, setResult] = useState("");
  const [error, setError] = useState("");

  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const open = useSelector(defaultSupporterOpenAddSelector);
  // -------------------------- FUNCTION ------------------------

  const handleReset = async () => {
    if (scanner) {
      scanner?.current?.stop();
      scanner?.current?.destroy();
    } else {
      scanner?.current?.start();
    }

    setResult("");
    setError("");
  };
  // khởi tạo
  const initScannerQR = useCallback(async () => {
    try {
      // Truy cập stream camera
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "environment" }, // Ưu tiên camera sau
      });

      // Khởi tạo QrScanner
      if (webcamRef?.current) {
        scanner.current = new QrScanner(
          webcamRef?.current?.video,
          (result) => {
            setResult(result.data);
            scanner?.current?.stop(); // Dừng quét sau khi tìm thấy kết quả
          },
          {
            highlightScanRegion: true,
            highlightCodeOutline: true,
          },
        );

        await scanner?.current?.start();
      }
    } catch (err) {
      setError(err.message || "Không thể truy cập camera");
    }
  }, []);
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (open) {
      initScannerQR();
    } else {
      if (scanner) {
        scanner?.current?.stop();
        scanner?.current?.destroy();
      }
    }

    return () => {
      if (scanner) {
        scanner?.current?.stop();
        scanner?.current?.destroy();
      }
    };
  }, [open]);

  console.log({ result });

  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <div
      style={{
        width: "100%",
        maxWidth: "500px",
        margin: "10px auto",
        border: "2px solid #007bff",
        borderRadius: "8px",
        overflow: "hidden",
      }}
    >
      {result === "" ? (
        <Webcam
          ref={webcamRef}
          audio={false}
          screenshotFormat="image/jpeg"
          videoConstraints={{
            facingMode: "environment",
          }}
          style={{ width: "100%" }}
        />
      ) : null}
      {loading ? (
        <div className="flex min-h-[200px] w-[100%] flex-col items-center justify-center gap-2">
          <Spin indicator={<LoadingOutlined spin />} />
          <span>Đang quét...</span>
        </div>
      ) : null}

      {error === "" ? null : (
        <div
          style={{
            minHeight: 300,
            minWidth: "500px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 10,
          }}
        >
          <Button onClick={handleReset} icon={<ScanOutlined />} type="primary">
            Thử lại
          </Button>
          <span>Mã QR không đúng</span>
        </div>
      )}

      {error && <p style={{ color: "red", marginTop: "20px" }}>Lỗi: {error}</p>}
      <TriggerClient handleSearchById={handleSearchById} result={result} />
    </div>
  );
};
export default QRScanner;
